import * as React from 'react';
import styled from 'styled-components';
import { VehicleAttachment as VehicleAttachmentT } from '../../../typedefs/store';
import { formatCurrency } from '../../../util';

interface Props {
    attachment: VehicleAttachmentT;
    openLinksExternally: boolean;
}

interface State {}

class VehicleAttachment extends React.Component<Props, State> {
    viewVehicle = () => {
        if (this.props.attachment.link) {
            window.open(
                this.props.attachment.link,
                this.props.openLinksExternally ? '_blank' : '_self',
            );
        }
    };

    render() {
        const { attachment } = this.props;
        return (
            <Wrapper onClick={this.viewVehicle}>
                {attachment.thumbnail && <img src={attachment.thumbnail} />}
                <div>
                    <Title>
                        {attachment.year} {attachment.make} {attachment.model} {attachment.trim}
                    </Title>
                    {attachment.colorExt && (
                        <Details>
                            <Label>Color</Label>: {attachment.colorExt}
                        </Details>
                    )}
                    {attachment.colorInt && (
                        <Details>
                            <Label>Interior Color</Label>: {attachment.colorInt}
                        </Details>
                    )}
                    {attachment.price && (
                        <Details>
                            <Label>Price</Label>: {formatCurrency(attachment.price, 0)}
                        </Details>
                    )}
                </div>
            </Wrapper>
        );
    }
}

export default VehicleAttachment;

const Wrapper = styled.div`
    cursor: pointer;
    img {
        max-width: 100%;
    }
`;

const Title = styled.div`margin-bottom: 10px;`;

const Details = styled.div`font-size: 0.8em;`;

const Label = styled.span`font-weight: 400;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/VehicleAttachment.tsx